import { render, staticRenderFns } from "./AlarmLevelParamsTab.vue?vue&type=template&id=c2dc752a&scoped=true&"
import script from "./AlarmLevelParamsTab.vue?vue&type=script&lang=js&"
export * from "./AlarmLevelParamsTab.vue?vue&type=script&lang=js&"
import style0 from "./AlarmLevelParamsTab.vue?vue&type=style&index=0&id=c2dc752a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dc752a",
  null
  
)

export default component.exports